<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <div class="level">
      <div class="level-left">
        <h4 class="title is-4">{{ createOrUpdate }}</h4>
      </div>
      <div class="level-right">
        <button :class="buttonSave" @click="saveEmployee">Save</button>
        <span v-show="this.employee.employeeId !== 0">
          &nbsp;
          <router-link
            :to="{
              name: 'Job History of Employee',
              params: { employeeId: this.$route.params.employeeId }
            }"
            class="button is-small is-info"
            >Job histories</router-link
          >
          &nbsp;
          <router-link
            :to="{
              name: 'Document Of Employee',
              params: { employeeId: this.$route.params.employeeId }
            }"
            class="button is-small is-info"
          >
            Scanned docs ({{ employee.totalScannedDoc }})</router-link
          >
        </span>
        &nbsp;
        <router-link :to="{ name: 'List Of Employees' }" class="button is-small"
          >Go back to list</router-link
        >
      </div>
    </div>
    <div class="is-divider" data-content="Personal Info"></div>
    <div class="columns">
      <div class="column is-3">
        <label class="label is-small">Profile picture</label>
        <div class="control">
          <span v-if="profileImagePreview">
            <img
              :src="profileImagePreview"
              width="200"
              height="200"
              border="1"
            />
          </span>
          <span v-else>
            <span v-if="isLoadingImage">
              <img
                src="../../assets/loading.gif"
                width="200"
                height="200"
                border="1"
              />
            </span>
            <span v-else>
              <img
                src="../../assets/user-6.png"
                width="200"
                height="200"
                border="1"
              />
            </span>
          </span>
          <br />
          <input
            type="file"
            @change="fileChange($event.target.files)"
            ref="profileImageInput"
          />
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small"
            >Employee ID
            <b-checkbox
              size="is-small"
              v-model="employee.isInActive"
              class="checkbox-in-employee"
              >Inactive profile</b-checkbox
            >
          </label>
          <div class="control">
            <input
              type="number"
              v-model="employee.employeeIdNumber"
              class="input is-small"
              v-validate="'required|numeric'"
              name="Employee id number"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Employee id number')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Lastname</label>
          <div class="control">
            <input
              type="text"
              v-model="employee.lastname"
              class="input is-small"
              v-validate="'required'"
              name="Lastname"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Lastname')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Firstname</label>
          <div class="control">
            <input
              type="text"
              v-model="employee.firstname"
              class="input is-small"
              v-validate="'required'"
              name="Firstname"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Firstname')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">MiddleName</label>
          <div class="control">
            <input
              type="text"
              v-model="employee.middlename"
              class="input is-small"
              v-validate="'required'"
              name="Middle name"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Middle name')
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Birthdate</label>
          <div class="control">
            <input
              type="date"
              v-model="employee.birthdate"
              class="input is-small"
              v-validate="'required'"
              name="Birth date"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Birth date')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Marital Status</label>
          <div class="control">
            <b-radio
              v-model="employee.maritalStatus"
              size="is-small"
              native-value="0"
              >Single</b-radio
            >
            <b-radio
              v-model="employee.maritalStatus"
              size="is-small"
              native-value="1"
              >Married</b-radio
            >
            <b-radio
              v-model="employee.maritalStatus"
              size="is-small"
              native-value="2"
              >Widowed</b-radio
            >
            <b-radio
              v-model="employee.maritalStatus"
              size="is-small"
              native-value="3"
              >Divorced</b-radio
            >
          </div>
        </div>
      </div>
      <div class="column">
        <label class="label is-small">Gender</label>
        <div class="control">
          <b-radio v-model="employee.gender" size="is-small" native-value="0"
            >Male</b-radio
          >
          <b-radio v-model="employee.gender" size="is-small" native-value="1"
            >Female</b-radio
          >
        </div>
      </div>
      <div class="column"></div>
    </div>
    <div class="is-divider" data-content="Job Description"></div>
    <div class="columns">
      <div class="column is-3">
        <div class="field">
          <div class="control">
            <div class="field">
              <label class="label is-small">Job Title & Department</label>
              <div class="control">
                <b-autocomplete
                  v-model="jobTitleName"
                  size="is-small"
                  :data="jobTitles"
                  placeholder="Search job titles"
                  @select="option => (selectedJobTitle = option)"
                  @input="searchJobTitles"
                  :loading="isFetchingJobTitles"
                  v-validate="'required'"
                  name="Job title and Department"
                >
                  <template slot="empty">
                    <span v-if="isFetchingJobTitles">
                      Please wait...
                    </span>
                    <span v-if="jobTitles.length === 0">
                      No results found
                    </span>
                  </template>
                </b-autocomplete>
                <span style="font-size:12px" class="has-text-danger">{{
                  errors.first('Job title and Department')
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Employee type</label>
          <div class="control">
            <div class="select is-small">
              <select v-model="employee.employeeType">
                <option value="0">Probationary</option>
                <option value="1">Regular</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Date hired</label>
          <div class="control">
            <input
              type="date"
              v-model="employee.dateHired"
              class="input is-small"
              v-validate="'required'"
              name="Date hired"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Date hired')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <div class="control">
            <div class="field">
              <label class="label is-small">Branch (Code & Name)</label>
              <div class="control">
                <b-autocomplete
                  v-model="branchName"
                  size="is-small"
                  :data="branches"
                  placeholder="Search branches"
                  @select="option => (selectedBranch = option)"
                  @input="searchBranches"
                  :loading="isFetchingBranches"
                  v-validate="'required'"
                  name="Branch"
                >
                  <template slot="empty">
                    <span v-if="isFetchingBranches">
                      Please wait...
                    </span>
                    <span v-if="branches.length === 0">
                      No results found
                    </span>
                  </template>
                </b-autocomplete>
                <span style="font-size:12px" class="has-text-danger">{{
                  errors.first('Branch')
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Effective Date</label>
          <div class="control">
            <input
              type="date"
              v-model="employee.effectiveDate"
              class="input is-small"
              v-validate="'required'"
              name="Effective date"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Effective date')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Scheduled Time in</label>
          <div class="control">
            <input
              type="time"
              v-model="employee.scheduledTimeIn"
              class="input is-small"
              v-validate="'required'"
              name="Time in"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Time in')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Scheduled Time Out</label>
          <div class="control">
            <input
              type="time"
              v-model="employee.scheduledTimeOut"
              class="input is-small"
              v-validate="'required'"
              name="Time out"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Time out')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Reason</label>
          <div class="control">
            <input
              type="text"
              v-model="employee.reason"
              class="input is-small"
              v-validate="'required'"
              name="Reason"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Reason')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small"
            >Intermediate supervisor
            <b-checkbox
              size="is-small"
              v-model="isNoIntermediateSupervisor"
              class="checkbox-in-employee"
              >None</b-checkbox
            >
          </label>
          <div class="control">
            <b-autocomplete
              v-model="intermediateSuperiorEmployeeName"
              :disabled="disabledIntermediateSupervisor"
              size="is-small"
              :data="employees"
              placeholder="Search employees"
              @select="option => (selectedEmployee = option)"
              @input="searchEmployees"
              :loading="isFetchingEmployees"
            >
              <template slot="empty">
                <span v-if="isFetchingEmployees">
                  Please wait...
                </span>
                <span v-if="employees.length === 0">
                  No results found
                </span>
              </template>
            </b-autocomplete>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Work day(s) in a week</label>
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <b-checkbox size="is-small" v-model="employee.isMonday"
            >Monday</b-checkbox
          >
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <b-checkbox size="is-small" v-model="employee.isTuesday"
            >Tuesday</b-checkbox
          >
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <b-checkbox size="is-small" v-model="employee.isWednesday"
            >Wednesday</b-checkbox
          >
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <b-checkbox size="is-small" v-model="employee.isThursday"
            >Thursday</b-checkbox
          >
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <b-checkbox size="is-small" v-model="employee.isFriday"
            >Friday</b-checkbox
          >
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <b-checkbox size="is-small" v-model="employee.isSaturday"
            >Saturday</b-checkbox
          >
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <b-checkbox size="is-small" v-model="employee.isSunday"
            >Sunday</b-checkbox
          >
        </div>
      </div>
    </div>
    <div class="is-divider" data-content="Contact Info"></div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Contact Number</label>
          <div class="control">
            <input
              type="text"
              v-model="employee.contactNumber"
              class="input is-small"
              v-validate="'required'"
              name="Contact number"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Contact number')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Email Address</label>
          <div class="control">
            <input
              type="text"
              v-model="employee.emailAddress"
              class="input is-small"
              v-validate="'required|email'"
              name="Email address"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Email address')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Permanent Address</label>
          <div class="control">
            <input
              type="text"
              v-model="employee.permanentAddress"
              class="input is-small"
              v-validate="'required'"
              name="Permanent address"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Permanent address')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Present Address</label>
          <div class="control">
            <input
              type="text"
              v-model="employee.presentAddress"
              class="input is-small"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="is-divider" data-content="In case of emergency"></div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Contact Person</label>
          <div class="control">
            <input
              type="text"
              v-model="employee.contactPerson"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Contact #</label>
          <div class="control">
            <input
              type="text"
              v-model="employee.contactPersonNumber"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Relationship</label>
          <div class="control">
            <input
              type="text"
              v-model="employee.contactRelationship"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column"></div>
    </div>
    <div class="is-divider" data-content="Payroll Info"></div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small"
            >SSS
            <b-checkbox
              size="is-small"
              v-model="employee.includeSss"
              class="checkbox-in-employee"
              >Include SSS</b-checkbox
            >
          </label>
          <div class="control">
            <input type="text" v-model="employee.sss" class="input is-small" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small"
            >PhilHealth
            <b-checkbox
              size="is-small"
              v-model="employee.includePhilhealth"
              class="checkbox-in-employee"
              >Include PhilHealth</b-checkbox
            >
          </label>
          <div class="control">
            <input
              type="text"
              v-model="employee.philhealth"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small"
            >PagIBIG
            <b-checkbox
              size="is-small"
              v-model="employee.includePagibig"
              class="checkbox-in-employee"
              >Include PagIBIG</b-checkbox
            >
          </label>
          <div class="control">
            <input
              type="text"
              v-model="employee.pagibig"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small"
            >TIN
            <b-checkbox
              size="is-small"
              v-model="employee.includeTax"
              class="checkbox-in-employee"
              >Include TIN</b-checkbox
            >
          </label>
          <div class="control">
            <input type="text" v-model="employee.tin" class="input is-small" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">&nbsp;</label>
          <div class="control">
            <b-checkbox size="is-small" v-model="employee.isLateExempt"
              >Is late exempt?</b-checkbox
            >
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Monthly Salary (w/o De Minimis)</label>
          <div class="control">
            <input
              type="number"
              v-model="employee.salaryWithoutAllowance"
              style="text-align:right;"
              class="input is-small"
              v-validate="'required|decimal'"
              name="Monthly salary"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Monthly salary')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">&nbsp;</label>
          <div class="control">
            <b-checkbox
              size="is-small"
              v-model="isNodeminimis"
              class="checkbox-in-employee"
              >Don't Include deminimis</b-checkbox
            >
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Transportation</label>
          <div class="control">
            <input
              type="number"
              v-model="employee.tranpo"
              style="text-align:right;"
              class="input is-small"
              v-validate="'decimal'"
              name="Transportation"
              :disabled="isNodeminimis"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Transportation')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Medical</label>
          <div class="control">
            <input
              type="number"
              v-model="employee.medical"
              style="text-align:right;"
              class="input is-small"
              v-validate="'decimal'"
              name="Medical"
              :disabled="isNodeminimis"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Medical')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Clothing</label>
          <div class="control">
            <input
              type="number"
              v-model="employee.clothing"
              style="text-align:right;"
              class="input is-small"
              v-validate="'decimal'"
              name="Clothing"
              :disabled="isNodeminimis"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Clothing')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Rice Subsidy</label>
          <div class="control">
            <input
              type="number"
              v-model="employee.riceSubsidy"
              style="text-align:right;"
              class="input is-small"
              v-validate="'decimal'"
              name="Rice Subsidy"
              :disabled="isNodeminimis"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Rice Subsidy')
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small"
            >Medicard amount
            <b-checkbox
              size="is-small"
              v-model="employee.hasMedicard"
              class="checkbox-in-employee"
              >Include</b-checkbox
            >
          </label>
          <div class="control">
            <input
              type="number"
              v-model="employee.medicardAmountMonthly"
              class="input is-small"
              style="text-align:right;"
              :disabled="disabledMedicardAmount"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Salary Term</label>
          <div class="control">
            <b-radio
              name="salary term"
              v-validate="'required'"
              v-model="employee.salaryTerm"
              size="is-small"
              native-value="0"
              >Daily</b-radio
            >
            <b-radio
              name="salary term"
              v-validate="'required'"
              v-model="employee.salaryTerm"
              size="is-small"
              native-value="1"
              >Weekly</b-radio
            >
            <b-radio
              name="salary term"
              v-validate="'required'"
              v-model="employee.salaryTerm"
              size="is-small"
              native-value="2"
              >Semi-Monthly</b-radio
            >
            <b-radio
              name="salary term"
              v-validate="'required'"
              v-model="employee.salaryTerm"
              size="is-small"
              native-value="3"
              >Monthly</b-radio
            >
          </div>
          <span class="help is-danger" v-show="errors.has('salary term')">{{
            errors.first('salary term')
          }}</span>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Monthly Salary</label>
          <div class="control">
            <input
              type="number"
              readonly
              v-model="employee.monthlySalary"
              style="text-align:right;"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small"
            >Regular Days of Work (In a month)</label
          >
          <div class="control">
            <input
              type="number"
              v-model="employee.regularWorkingDaysInaMonth"
              class="input is-small"
              v-validate="'required|numeric'"
              name="Regular days of work"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Regular days of work')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Number of Leaves</label>
          <div class="control">
            <input
              type="text"
              v-model="employee.numberOfLeaves"
              class="input is-small"
              placeholder="0.0"
              v-validate="'required|decimal:2'"
              name="Number of leaves"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Number of leaves')
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left">
        &nbsp;
      </div>
      <div class="level-right">
        <button :class="buttonSave" @click="saveEmployee">Save</button>
        &nbsp;
        <router-link :to="{ name: 'List Of Employees' }" class="button is-small"
          >Go back to list</router-link
        >
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import debounce from 'lodash/debounce'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data: () => ({
    profile: new FormData(),
    employee: {
      employeeId: 0,
      employeeType: 0,
      maritalStatus: 0,
      presentAddress: '',
      permanentAddress: '',
      gender: 0,
      jobTitleId: 0,
      sss: '',
      philhealth: '',
      pagibig: '',
      tin: '',
      tranpo: 0,
      medical: 0,
      clothing: 0,
      riceSubsidy: 0,
      includeSss: false,
      includePhilhealth: false,
      includePagibig: false,
      includeTax: false,
      contactPerson: '',
      contactPersonNumber: '',
      isLateExempt: false,
      isMonday: true,
      isTuesday: true,
      isWednesday: true,
      isThursday: true,
      isFriday: true,
      isSaturday: false,
      isSunday: false,
      monthlySalary: 0,
      isInActive: false,
      hasMedicard: false,
      medicardAmountMonthly: 0
    },
    isNoIntermediateSupervisor: false,
    disabledIntermediateSupervisor: false,
    isLoading: false,
    isLoadingImage: false,
    createOrUpdate: 'Create',
    // select
    jobTitleName: '',
    jobTitles: [],
    selectedJobTitle: 0,
    isFetchingJobTitles: false,

    branchName: '',
    branches: [],
    selectedBranch: 0,
    isFetchingBranches: false,

    intermediateSuperiorEmployeeName: '',
    employees: [],
    selectedEmployee: 0,
    isFetchingEmployees: false,

    buttonSave: appButton.isLoadingSuccess(false),
    isNodeminimis: false,
    profileImagePreview: null
  }),
  created() {
    const employeeId = this.$route.params.employeeId
    if (employeeId) {
      this.createOrUpdate = '...'
      this.getEmployeeById(employeeId)
      this.getEmployeeImageById(employeeId)
    }
  },
  computed: {
    disabledMedicardAmount() {
      return this.employee.hasMedicard ? false : true
    }
  },
  methods: {
    default() {
      this.$nextTick(() => {
        this.$validator.reset()
      })
      this.disabledIntermediateSupervisor = false
      this.isNoIntermediateSupervisor = false
      this.profile = new FormData()
      this.employee = {
        employeeId: 0,
        employeeType: 0,
        maritalStatus: 0,
        presentAddress: '',
        permanentAddress: '',
        gender: 0,
        jobTitleId: 0,
        sss: '',
        philhealth: '',
        pagibig: '',
        tin: '',
        tranpo: 0,
        medical: 0,
        clothing: 0,
        riceSubsidy: 0,
        includeSss: false,
        includePhilhealth: false,
        includePagibig: false,
        includeTax: false,
        contactPerson: '',
        contactPersonNumber: '',
        isLateExempt: false,
        isMonday: true,
        isTuesday: true,
        isWednesday: true,
        isThursday: true,
        isFriday: true,
        isSaturday: false,
        isSunday: false,
        monthlySalary: 0,
        isInActive: false,
        hasMedicard: false,
        medicardAmountMonthly: 0
      }
      this.isLoading = false
      this.isLoadingImage = false
      this.jobTitleName = ''
      this.selectedJobTitle = 0
      this.isFetchingJobTitles = false

      this.branchName = ''
      this.selectedBranch = 0
      this.isFetchingBranches = false

      this.intermediateSuperiorEmployeeName = ''
      this.employees = []
      this.selectedEmployee = 0
      this.isFetchingEmployees = false

      this.isNodeminimis = false

      this.profileImagePreview = null
      this.$refs.profileImageInput.value = ''

      this.buttonSave = appButton.isLoadingSuccess(false)
    },
    searchJobTitles: debounce(function() {
      this.isFetchingJobTitles = true
      axios
        .get(`api/jobtitles/search-by-name/${this.jobTitleName}`)
        .then(response => {
          this.jobTitles = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isFetchingJobTitles = false
        })
    }, 500),
    searchBranches: debounce(function() {
      this.isFetchingBranches = true
      axios
        .get(`api/branches/search-by-name/${this.branchName}`)
        .then(response => {
          this.branches = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isFetchingBranches = false
        })
    }, 500),
    fileChange(file) {
      for (let i = 0; i < file.length; i++) {
        this.profile.append('profilePhoto', file[i], file[i].name)
      }

      this.profileImagePreview = URL.createObjectURL(file[0])
    },
    saveEmployee() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.buttonSave = appButton.isLoadingSuccess(true)
          const employeeId = this.employee.employeeId

          this.employee.isNoIntermediateSupervisor = this.isNoIntermediateSupervisor
          this.employee.isNoDeminimis = this.isNodeminimis
          if (this.isNoIntermediateSupervisor) {
            this.employee.intermediateSupervisor = null
          } else {
            if (!this.employee.intermediateSupervisor) {
              appToast.danger(
                'Intermediate supervisor is empty. Please select one or check "None" if this employee has no intermediate supervisor.'
              )
              this.buttonSave = appButton.isLoadingSuccess(false)
              return false
            }
          }

          this.profile.append('profileDetail', JSON.stringify(this.employee))

          if (employeeId === 0) {
            // CREATE
            axios
              .get(
                `api/employees/check-employee-id-if-exists/${this.employee.employeeIdNumber}`
              )
              .then(response => {
                if (!response.data) {
                  axios
                    .post(`api/employees`, this.profile)
                    .then(response => {
                      appToast.success(response.data)
                    })
                    .catch(error => {
                      console.log(error)
                    })
                    .then(() => {
                      this.default()
                    })
                } else {
                  appToast.danger('Employee ID # already exists')
                  this.buttonSave = appButton.isLoadingSuccess(false)
                  return false
                }
              })
              .catch(error => console.log(error))
          } else {
            // EDIT
            axios
              .post(`api/employees/create-job-history/`, this.profile)
              .then(response => {
                axios
                  .put(`api/employees/${employeeId}`, this.profile)
                  .then(response => {
                    appToast.success(response.data)
                  })
                  .catch(error => console.log(error))
                  .then(() => {
                    this.default()
                    this.buttonSave = appButton.isLoadingSuccess(false)
                    this.getEmployeeById(this.$route.params.employeeId)
                    this.getEmployeeImageById(this.$route.params.employeeId)
                  })
              })
              .catch(error => console.log(error))
          }
        }
      })
    },
    getEmployeeImageById(id) {
      this.isLoadingImage = true
      axios
        .get(`api/employees/profile-image-byte/${id}`)
        .then(response => {
          this.profileImagePreview = `data:image/jpg;base64, ${response.data}`
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isLoadingImage = false
        })
    },
    getEmployeeById(id) {
      this.isLoading = true
      axios
        .get(`api/employees/${id}`)
        .then(response => {
          response.data.dateHired = moment(response.data.dateHired).format(
            'YYYY-MM-DD'
          )
          response.data.effectiveDate = moment(
            response.data.effectiveDate
          ).format('YYYY-MM-DD')
          response.data.birthdate = moment(response.data.birthdate).format(
            'YYYY-MM-DD'
          )
          this.jobTitleName = response.data.jobTitle
          this.branchName = response.data.branch
          this.isNodeminimis = response.data.isNoDeminimis
          this.isNoIntermediateSupervisor =
            response.data.isNoIntermediateSupervisor
          this.employee = response.data

          if (response.data.intermediateSupervisor) {
            this.isFetchingEmployees = true
            axios
              .get(`api/employees/name/${response.data.intermediateSupervisor}`)
              .then(response => {
                this.intermediateSuperiorEmployeeName = response.data
              })
              .catch(error => console.log(error))
              .then(() => (this.isFetchingEmployees = false))
          }
        })
        .catch(error => {
          console.log(error)
          alert('Something went wrong. User might not be found.')
        })
        .then(() => {
          this.isLoading = false
          this.createOrUpdate = `Update ${this.employee.firstname} ${this.employee.lastname}`
        })
    },
    searchEmployees: debounce(function() {
      this.isFetchingEmployees = true
      axios
        .get(
          `api/employees/search-by-name/${this.intermediateSuperiorEmployeeName}`
        )
        .then(response => {
          this.employees = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isFetchingEmployees = false
        })
    }, 500)
  },
  watch: {
    isNoIntermediateSupervisor() {
      if (this.isNoIntermediateSupervisor) {
        this.intermediateSuperiorEmployeeName = ''
        this.selectedEmployee = 0
        this.disabledIntermediateSupervisor = true
      } else {
        this.disabledIntermediateSupervisor = false
      }
    },
    selectedJobTitle() {
      if (this.selectedJobTitle) {
        this.employee.jobTitleId = this.selectedJobTitle.id
      }
    },
    selectedBranch() {
      if (this.selectedBranch) {
        this.employee.branchId = this.selectedBranch.id
      }
    },
    isNodeminimis() {
      if (this.isNodeminimis) {
      } else {
      }
    },
    selectedEmployee() {
      if (this.selectedEmployee) {
        this.employee.intermediateSupervisor = this.selectedEmployee.pkey
      } else {
        this.employee.intermediateSupervisor = null
      }
    }
  }
}
</script>
